import React, { useContext } from 'react';
import {
  Button,
  Dialog,
  makeStyles,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Tooltip,
  IconButton,
  Paper,
  Fade,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { Fragment } from 'react';
import notificationsAPI from '../services/NotificationsApi';
import { AppContext } from '../contexts/AppContext';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '1em',
    margin: '0 0 1em 0',
    transition: '0.3s !important',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1em',
  },
}));

const tooltipDelay = 1000;

const NotificationModal = ({ notifications, setNotifications, open, setOpen }) => {
  const { showError } = useContext(AppContext);

  const deleteNotification = id => {
    notificationsAPI
      .deleteNotification({ State: true }, id)
      .then(result => setNotifications(notifications.filter(n => n.id !== id)))
      .catch(error => showError('Error al descartar notificacion'));
  };

  const deleteAll = () => {
    notificationsAPI
      .deleteAll()
      .then(result => {
        setOpen(false);
        setTimeout(() => {
          setNotifications([]);
        }, 250);
      })
      .catch(error => showError('Error al descartar notificacion'));
  };

  const NotificationBox = ({ notification, handleDelete }) => {
    const classes = useStyles();

    return (
      <Fade in={true}>
        <Paper className={classes.container} elevation={3}>
          <div className={classes.content}>
            <Typography variant="subtitle1">{`${notification.area} ${notification.title}`}</Typography>
            <Typography variant="body2" style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              overflowWrap: 'break-word'
            }}>{notification.content.length > 300
              ? `${notification.content.slice(0, 300)}...`
              : notification.content}
            </Typography>
            <div className={classes.actions}>
              <Tooltip title={'Descartar'} enterDelay={tooltipDelay}>
                <IconButton aria-label="visualizar" size="small" color="secondary" onClick={() => handleDelete(notification.id)}>
                  <Delete />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </Paper>
      </Fade>
    );
  };

  const EmptyNotificationsBody = ({ setOpen }) => (
    <Fragment>
      <DialogContent dividers>No hay notificaciones para mostrar</DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cerrar</Button>
      </DialogActions>
    </Fragment>
  );

  const NotificationsBody = ({ setOpen, notifications, deleteNotification, deleteAll }) => {
    return (
      <Fragment>
        <DialogContent dividers>
          {notifications
          .filter(notif => !notif.read)
          .map(notif => (
            <NotificationBox key={notif.idNotification} notification={notif} handleDelete={deleteNotification} />
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteAll} color="secondary">
            Descartar todas
          </Button>
          <Button onClick={() => setOpen(false)}>Cerrar</Button>
        </DialogActions>
      </Fragment>
    );
  };

  return (
    <Dialog onClose={() => setOpen(false)} scroll="body" aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle id="customized-dialog-title">Notificaciones</DialogTitle>
      {notifications.isEmpty() ? (
        <EmptyNotificationsBody setOpen={setOpen} />
      ) : (
        <NotificationsBody setOpen={setOpen} notifications={notifications} deleteNotification={deleteNotification} deleteAll={deleteAll} />
      )}
    </Dialog>
  );
};

export default NotificationModal;
